function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { extractFirstUrl } from '@edusense/entities-social';
import { ContentMediaGrid } from '@edusense/entities-media';
// 스타일 컴포넌트
import { ContentBaseWrapper, ContentBaseText, ExpandButton } from './styles/contentbase.styles';
// 유틸리티 함수
import { processTextWithLinks, checkYoutubeUrl } from './utils';
// 하위 렌더러 컴포넌트
import PollRenderer from './PollRenderer';
import LinkPreviewRenderer from './LinkPreviewRenderer';
import QuotedContentRenderer from './QuotedContentRenderer';
/**
 * 통합 콘텐츠 컴포넌트
 * 
 * 트윗 스타일 기반으로 통합된 콘텐츠 컴포넌트
 * 접기/펼치기 기능을 선택적으로 사용할 수 있습니다.
 */ var ContentBase = function(param) {
    var _param_content = param.content, content = _param_content === void 0 ? '' : _param_content, _param_images = param.images, images = _param_images === void 0 ? [] : _param_images, _param_videos = param.videos, videos = _param_videos === void 0 ? [] : _param_videos, linkPreview = param.linkPreview, linkPreviewData = param.linkPreviewData, poll = param.poll, quotedContent = param.quotedContent, quotedTweet = param.quotedTweet, onImageClick = param.onImageClick, onVote = param.onVote, onQuotedContentClick = param.onQuotedContentClick, _param_renderContent = param.renderContent, renderContent = _param_renderContent === void 0 ? true : _param_renderContent, _param_renderMediaGrid = param.renderMediaGrid, renderMediaGrid = _param_renderMediaGrid === void 0 ? true : _param_renderMediaGrid, _param_renderLinkPreview = param.renderLinkPreview, renderLinkPreview = _param_renderLinkPreview === void 0 ? true : _param_renderLinkPreview, _param_renderPoll = param.renderPoll, renderPoll = _param_renderPoll === void 0 ? true : _param_renderPoll, _param_renderQuotedContent = param.renderQuotedContent, renderQuotedContent = _param_renderQuotedContent === void 0 ? true : _param_renderQuotedContent, className = param.className, _param_isExpandable = param.isExpandable, isExpandable = _param_isExpandable === void 0 ? false : _param_isExpandable, _param_autoDetectLinks = param.autoDetectLinks, autoDetectLinks = _param_autoDetectLinks === void 0 ? true : _param_autoDetectLinks;
    var _quotedTweet_author, _quotedTweet_author1, _quotedTweet_author2, _quotedTweet_author3, _quotedTweet_author4;
    // useNavigate를 안전하게 사용하기 위한 래퍼 함수
    var navigate;
    try {
        // Router 컨텍스트가 있는 경우 정상적으로 useNavigate 사용
        var reactRouterNavigate = useNavigate();
        navigate = function(path) {
            // content-ui 도메인 컴포넌트에서는 직접 네비게이션보다 콜백 사용을 권장
            console.warn('ContentBase: 직접 네비게이션보다 onQuotedContentClick 콜백 사용을 권장합니다.');
            reactRouterNavigate(path);
        };
    } catch (error) {
        // Router 컨텍스트가 없는 경우 (예: Storybook) mock 함수 사용
        navigate = function(path) {
            console.warn("ContentBase: Router context가 없어 ".concat(path, " 네비게이션이 무시되었습니다. onQuotedContentClick 콜백을 사용하세요."));
        };
    }
    // 콘텐츠 확장 상태 관리
    var _useState = _sliced_to_array(useState(false), 2), isExpanded = _useState[0], setIsExpanded = _useState[1];
    // 콘텐츠 길이 체크
    var longContent = content.length > 280;
    // 자동 링크 미리보기 처리
    var _useState1 = _sliced_to_array(useState(null), 2), autoLinkPreview = _useState1[0], setAutoLinkPreview = _useState1[1];
    // 자동 링크 감지
    useEffect(function() {
        if (autoDetectLinks && !linkPreviewData && !linkPreview && content) {
            var firstUrl = extractFirstUrl(content);
            if (firstUrl) {
                try {
                    var isYoutube = checkYoutubeUrl(firstUrl);
                    var hostname = new URL(firstUrl).hostname.replace('www.', '');
                    setAutoLinkPreview({
                        url: firstUrl,
                        title: isYoutube ? '유튜브 영상' : '웹사이트 링크',
                        description: isYoutube ? '유튜브 콘텐츠' : '웹사이트 콘텐츠',
                        imageUrl: undefined,
                        siteName: isYoutube ? 'YouTube' : hostname,
                        type: isYoutube ? 'youtube' : 'website'
                    });
                } catch (error) {
                    console.error('URL 파싱 오류:', error);
                }
            }
        }
    }, [
        content,
        linkPreviewData,
        linkPreview,
        autoDetectLinks
    ]);
    // 실제 사용할 링크 미리보기 데이터 통합
    var finalLinkPreviewData = linkPreview || (linkPreviewData ? {
        url: linkPreviewData.url,
        title: linkPreviewData.title,
        description: linkPreviewData.description,
        imageUrl: linkPreviewData.imageUrl,
        siteName: linkPreviewData.siteName,
        type: linkPreviewData.type
    } : autoLinkPreview ? {
        url: autoLinkPreview.url,
        title: autoLinkPreview.title,
        description: autoLinkPreview.description,
        imageUrl: autoLinkPreview.imageUrl,
        siteName: autoLinkPreview.siteName,
        type: autoLinkPreview.type
    } : undefined);
    // 인용된 콘텐츠 통합
    var finalQuotedContent = quotedContent || (quotedTweet ? {
        id: quotedTweet.id,
        content: quotedTweet.content || '',
        author: {
            id: ((_quotedTweet_author = quotedTweet.author) === null || _quotedTweet_author === void 0 ? void 0 : _quotedTweet_author.id) || '0',
            name: ((_quotedTweet_author1 = quotedTweet.author) === null || _quotedTweet_author1 === void 0 ? void 0 : _quotedTweet_author1.name) || quotedTweet.name || '알 수 없는 사용자',
            username: ((_quotedTweet_author2 = quotedTweet.author) === null || _quotedTweet_author2 === void 0 ? void 0 : _quotedTweet_author2.username) || quotedTweet.username || 'unknown',
            profileImage: ((_quotedTweet_author3 = quotedTweet.author) === null || _quotedTweet_author3 === void 0 ? void 0 : _quotedTweet_author3.profileImage) || quotedTweet.profileImage || '',
            verified: ((_quotedTweet_author4 = quotedTweet.author) === null || _quotedTweet_author4 === void 0 ? void 0 : _quotedTweet_author4.verified) || false
        },
        createdAt: quotedTweet.createdAt || new Date(),
        images: quotedTweet.images || [],
        videos: quotedTweet.videos || [],
        type: 'tweet'
    } : undefined);
    // 인용된 콘텐츠 클릭 핸들러
    var handleQuotedContentClick = function(id, type) {
        if (onQuotedContentClick) {
            onQuotedContentClick(id, type);
        } else {
            // 기본 이동 동작
            navigate("/".concat(type === 'tweet' ? 'post' : type, "/").concat(id));
        }
    };
    // 미디어 그리드 렌더링
    var renderMediaGridContent = function() {
        if (images.length === 0 && videos.length === 0) return null;
        return /*#__PURE__*/ React.createElement(ContentMediaGrid, {
            images: images,
            videos: videos,
            onImageClick: onImageClick,
            onVideoClick: onImageClick
        });
    };
    // 트윗 스타일로 통일된 렌더링
    return /*#__PURE__*/ React.createElement(ContentBaseWrapper, {
        className: className
    }, renderContent && content && /*#__PURE__*/ React.createElement(ContentBaseText, {
        $isClipped: isExpandable && longContent && !isExpanded
    }, processTextWithLinks(content)), isExpandable && longContent && /*#__PURE__*/ React.createElement(ExpandButton, {
        onClick: function(e) {
            e.stopPropagation();
            setIsExpanded(!isExpanded);
        }
    }, isExpanded ? '접기' : '더 보기'), renderMediaGrid && (images.length > 0 || videos.length > 0) && renderMediaGridContent(), renderQuotedContent && finalQuotedContent && /*#__PURE__*/ React.createElement(QuotedContentRenderer, {
        quotedContent: finalQuotedContent,
        onQuotedContentClick: handleQuotedContentClick
    }), renderLinkPreview && finalLinkPreviewData && /*#__PURE__*/ React.createElement(LinkPreviewRenderer, {
        linkPreviewData: finalLinkPreviewData
    }), renderPoll && poll && /*#__PURE__*/ React.createElement(PollRenderer, {
        poll: poll,
        onVote: onVote
    }));
};
export default ContentBase;
